import { mapGetters } from 'vuex'

import { get, omit } from 'lodash'

import { Services, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: 'Resend',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      loading: false,
      showDialog: false,
      asOwner: false
    }
  },

  computed: {
    ...mapGetters({ token: 'authentication/token' })
  },

  methods: {
    async resend() {
      if (this.value) {
        try {
          this.loading = true

          let token = this.token
          if (this.asOwner) {
            const result = await request.get(joinURLPath('login', 'as', get(this.value, 'Owner.id')))
            token = result.token
          }

          await request.create(Services.sendings, {
            headers: { Authorization: token },
            body: {
              type: get(this.value, 'type'),
              recipient: get(this.value, 'payload.recipient'),
              payload: omit(get(this.value, 'payload'), 'recipient')
            }
          })

          this.showDialog = false
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
